<template>
    <div class="profile px-4 px-md-8 py-4">
        <edit-profile-dialog v-model="editDialog" :employee="ClientUser.employeeCode"></edit-profile-dialog>
        <v-card-title>
            <span class="text-h5">Hồ sơ của bạn</span> <v-divider class="ml-4"></v-divider>
        </v-card-title>
        <v-card class="elevation-2 my-6 rounded-xl overflow-hidden">
            <!-- Header Background / Banner -->
            <div style="height: 120px; background: linear-gradient(135deg, #004D40, #00695C);" class="rounded-t-xl"></div>
            <v-row class="px-6 pb-4">
                <v-col cols="12" md="4" class="text-center" style="margin-top: -65px;">
                    <div class="avatar-wrapper mb-2 mx-auto" style="width: 160px; height: 160px; position: relative;">
                        <v-avatar class="profile elevation-6"
                            color="white" size="160" style="border: 4px solid #fff;">
                            <v-img :src="avatarUrl" ></v-img>
                        </v-avatar>
                        <v-btn fab dark small color="teal darken-3" class="elevation-4" 
                            style="position: absolute; bottom: 0; right: 0;" 
                            @click="showChangeAvatar = !showChangeAvatar"
                            title="Thay đổi avatar">
                            <v-icon>mdi-camera</v-icon>
                        </v-btn>
                    </div>
                    <div v-if="faceDetectRs === false || faceDetectRs === 'false'" class="mx-auto px-2 mt-4" style="max-width: 320px;">
                        <v-alert dense outlined type="error" icon="mdi-account-alert" border="left" class="text-caption text-left mb-0 py-2" style="line-height: 1.4;">
                            <strong>Cảnh báo:</strong> Avatar không đạt chuẩn! Yêu cầu tải lên ảnh chân dung rõ mặt của nhân sự.
                        </v-alert>
                    </div>
                    
                    <v-dialog v-model="showChangeAvatar" max-width="450px" persistent>
                        <v-card class="rounded-xl">
                            <v-card-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4">
                                Cập nhật ảnh đại diện
                                <v-spacer></v-spacer>
                                <v-btn icon @click="showChangeAvatar = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pt-6">
                                <v-file-input accept="image/*" v-model="newAvatar"
                                label="Chọn ảnh từ thiết bị" outlined prepend-inner-icon="mdi-image" prepend-icon="" hide-details="true" class="mb-2"></v-file-input>
                            </v-card-text>
                            <v-card-actions class="px-6 pb-6 pt-0">
                                <v-spacer></v-spacer>
                                <v-btn color="error" text @click="showChangeAvatar=false">Hủy</v-btn>
                                <v-btn color="success" depressed @click="changeAvatar" class="px-6 rounded-pill">Lưu</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    
                    <h2 class="text-h5 font-weight-bold mt-2 d-flex justify-center align-center">
                        {{ data.name }}
                        <v-icon :color="data.gender ? 'blue' : 'pink'" class="ml-1" size="24">
                            {{ data.gender ? 'mdi-gender-male': 'mdi-gender-female' }}
                        </v-icon>
                    </h2>
                    <div class="text-subtitle-1 text--secondary mb-2">{{ data.code }}</div>
                    
                    <v-chip color="teal lighten-5" text-color="teal darken-4" class="mb-2 font-weight-medium">
                        {{ data.departmentTypeName == 'Hỗ trợ'? '': 'Chi nhánh' }} {{ data.departmentName }}
                    </v-chip>
                    
                    <div class="mt-2 text-subtitle-2 font-weight-medium text--secondary">
                        {{ data.positionName != data.positionStateName ? data.positionName :'' }} {{data.positionStateName}}
                    </div>
                </v-col>
                
                <v-col cols="12" md="8" class="pt-8">
                    <v-row>
                        <!-- Basic Information -->
                        <v-col cols="12" md="6">
                            <h3 class="text-h6 font-weight-bold mb-4 d-flex align-center teal--text text--darken-4">
                                <v-icon color="teal darken-3" class="mr-2">mdi-account-circle-outline</v-icon> 
                                THÔNG TIN CƠ BẢN
                            </h3>
                            <v-list class="transparent pa-0">
                                <v-list-item class="px-0">
                                    <v-list-item-icon class="mr-4 mt-2">
                                        <v-icon color="teal darken-3">mdi-calendar</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Ngày sinh</v-list-item-subtitle>
                                        <v-list-item-title class="font-weight-medium">{{ formatDate(data.birthDay) || '—' }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-icon class="mr-4 mt-2">
                                        <v-icon color="teal darken-3">mdi-phone</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Số điện thoại / Email</v-list-item-subtitle>
                                        <v-list-item-title class="font-weight-medium">{{ data.phoneNumber || '—' }}</v-list-item-title>
                                        <v-list-item-subtitle class="mt-1">
                                            {{ data.mail || '—' }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-icon class="mr-4 mt-2">
                                        <v-icon color="teal darken-3">mdi-card-account-details-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Số CMND/CCCD</v-list-item-subtitle>
                                        <v-list-item-title class="font-weight-medium">{{ data.idNumber || '—' }}</v-list-item-title>
                                        <v-list-item-subtitle class="mt-1 text-wrap" style="line-height:1.5;">
                                            Cấp ngày {{ formatDate(data.idDate) }} tại {{ data.idPlace }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        
                        <!-- More Information -->
                        <v-col cols="12" md="6">
                            <h3 class="text-h6 font-weight-bold mb-4 d-flex align-center teal--text text--darken-4">
                                <v-icon color="teal darken-3" class="mr-2">mdi-map-marker-radius-outline</v-icon> 
                                ĐỊA CHỈ & HỌC VẤN
                            </h3>
                            <v-list class="transparent pa-0">
                                <v-list-item class="px-0">
                                    <v-list-item-icon class="mr-4 mt-2">
                                        <v-icon color="teal darken-3">mdi-home-map-marker</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Địa chỉ thường trú</v-list-item-subtitle>
                                        <v-list-item-title class="font-weight-medium text-wrap" style="line-height: 1.5;">
                                            {{ `${(data.address=='')?'':data.address+', '} ${data.ward==null?'':data.ward+', '} ${data.district==null?'':data.district+', '} ${data.city}`}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-icon class="mr-4 mt-2">
                                        <v-icon color="teal darken-3">mdi-map-marker-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Địa chỉ tạm trú</v-list-item-subtitle>
                                        <v-list-item-title class="font-weight-medium text-wrap" style="line-height: 1.5;">
                                            {{ `${(data.domicileAddress=='')?'':data.domicileAddress+', '} ${data.dWardName==null?'':data.dWardName+', '} ${data.dDistrict==null?'':data.dDistrict +', '} ${data.dCityName}`}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="px-0">
                                    <v-list-item-icon class="mr-4 mt-2">
                                        <v-icon color="teal darken-3">mdi-school-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Trình độ / Chuyên ngành</v-list-item-subtitle>
                                        <v-list-item-title class="font-weight-medium">{{ data.educationLevelName || '—' }}</v-list-item-title>
                                        <v-list-item-subtitle class="mt-1 text-wrap" style="line-height:1.5;">
                                            {{ data.educationMajorName || '—' }} ({{ data.universityName || '—' }})
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle class="mt-1 d-flex flex-wrap text-caption text--secondary">
                                            <span class="mr-3"><b>DT:</b> {{ data.ethnicity || '—' }}</span>
                                            <span class="mr-3"><b>TG:</b> {{ data.religion || '—' }}</span>
                                            <span><b>QT:</b> {{ data.origin || '—' }}</span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    
                    <v-row class="mt-0">
                        <v-col cols="12" class="pt-0">
                           <v-card outlined class="grey lighten-5 rounded-lg" style="border: 1px solid rgba(0,0,0,0.12) !important;">
                               <v-card-text class="d-flex align-center justify-space-between py-3 px-4 flex-wrap">
                                   <div class="d-flex align-center mb-2 mb-sm-0">
                                       <v-icon size="36" color="teal darken-3" class="mr-3">mdi-cellphone-link</v-icon>
                                       <div>
                                           <div class="text-caption font-weight-bold text--secondary text-uppercase tracking-wide">Mã cài đặt APP iOS</div>
                                           <div class="text-h6 font-weight-black teal--text text--darken-4" style="letter-spacing: 2px;">{{ iOSCode }}</div>
                                       </div>
                                   </div>
                                   <v-btn @click="getIosCode" rounded color="teal darken-4" dark elevation="2" class="px-4 font-weight-bold">
                                       <v-icon left size="20">mdi-qrcode-scan</v-icon> Tạo mã
                                   </v-btn>
                               </v-card-text>
                           </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        
        <v-card-title class="pa-0 mt-8 mb-4">
            <span class="text-h5">Thông tin công việc</span> <v-divider class="ml-4"></v-divider>
        </v-card-title>
        <v-row>
            <v-col cols="12" >
                <v-tabs background-color="transparent" color="teal darken-4" slider-color="teal darken-4" v-model="tabIndex" centered class="mb-4">
                    <v-tab @change="tabHistoryHandler" :key="0" class="font-weight-bold">
                        <v-icon left>mdi-file-document-outline</v-icon> Công việc & Hợp đồng
                    </v-tab>
                    <v-tab @change="tabEnrollmentHandler" :key="1" class="font-weight-bold">
                        <v-icon left>mdi-calendar-check</v-icon> Chấm công
                    </v-tab>
                </v-tabs>
                <v-card class="rounded-xl elevation-2 overflow-hidden" >
                    <v-tabs-items v-model="tabIndex">
                        <v-tab-item :key="0" class="py-6">
                            <!-- Contract Section -->
                            <div class="px-6 mb-10">
                                <div class="d-flex align-center mb-4">
                                    <v-icon color="teal darken-3" class="mr-3" size="28">mdi-file-certificate-outline</v-icon>
                                    <h3 class="text-h6 font-weight-bold teal--text text--darken-4 text-uppercase" style="letter-spacing: 1px;">Danh sách hợp đồng</h3>
                                </div>
                                <v-alert dense text type="info" color="teal" class="mb-6 rounded-lg">
                                    <div class="d-flex align-center">
                                        <v-icon small class="mr-2" color="teal darken-2">mdi-information-outline</v-icon>
                                        <span class="text-caption font-weight-medium">Nếu mở bằng trình duyệt Zalo sẽ không tải được file. Vui lòng mở bằng Safari (iPhone) hoặc Chrome.</span>
                                        <v-tooltip bottom color="teal darken-4">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon x-small v-bind="attrs" v-on="on" color="teal darken-4" class="ml-2">
                                                    <v-icon>mdi-help-circle-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <img src="/static/help/contract_help.jpg" width="220" class="rounded elevation-4">
                                        </v-tooltip>
                                    </div>
                                </v-alert>

                                <v-data-table :headers="contractHeader" :items="contractHistory" class="elevation-0 border-teal-lighten-5">
                                    <template v-slot:[`item.validFrom`]="{ item }">
                                        <span class="font-weight-medium text-no-wrap">{{ formatDate(item.validFrom) }}</span>
                                    </template>
                                    <template v-slot:[`item.validTo`]="{ item }">
                                        <span class="font-weight-medium text-no-wrap">{{ formatDate(item.validTo) }}</span>
                                    </template>
                                    <template v-slot:[`item.status`]="{ item }">
                                        <v-chip outlined class="font-weight-bold" x-small :color="contractStatusDict[item.status].color">
                                            {{ contractStatusDict[item.status].name.toUpperCase() }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.htmlSource`]="{ item }">
                                        <v-dialog hide-overlay transition="dialog-bottom-transition" max-width="850" scrollable>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="teal darken-3" dark x-small class="rounded-pill px-4" v-bind="attrs" v-on="on" depressed>
                                                    <v-icon left x-small>mdi-eye-outline</v-icon> Xem chi tiết
                                                </v-btn>
                                            </template>
                                            <v-card class="rounded-xl overflow-hidden">
                                                <v-card-title class="teal darken-4 white--text py-4">
                                                    <v-icon color="white" class="mr-3">mdi-file-document-edit-outline</v-icon>
                                                    Hợp đồng số: {{ item.contractNumber }}
                                                    <v-spacer></v-spacer>
                                                    <v-btn icon dark small @click="on.click"><v-icon>mdi-close</v-icon></v-btn>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text class="pa-8">
                                                    <div class="contract-content" v-html="item.htmlSource"></div>
                                                </v-card-text>
                                                <v-card-actions class="pa-8 grey lighten-4" v-if="item.status==2">
                                                    <div style="width: 100%;">
                                                        <v-alert dense outlined type="warning" class="text-caption mb-4 bg-white">
                                                            <strong>Quan trọng:</strong> Vui lòng kiểm tra kỹ tất cả điều khoản. Nếu có <b>sai sót</b> hãy ấn trả về và nhập ghi chú.
                                                        </v-alert>
                                                        <v-textarea v-model="contractNote" rows="3" outlined label="Nhập ghi chú phản hồi..." color="teal" class="mb-4 bg-white" hide-details="auto"></v-textarea>
                                                        <div class="d-flex justify-center mt-6">
                                                            <v-btn color="teal darken-4" dark class="rounded-pill mr-4 px-8" @click="changeContractStatus(item.id, 3)" depressed>Xác nhận Hợp đồng</v-btn>
                                                            <v-btn color="error" class="rounded-pill px-8" @click="changeContractStatus(item.id, 4)" depressed outlined>Trả về sửa lại</v-btn>
                                                        </div>
                                                    </div>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </template>
                                    <template v-slot:[`item.fileUrl`]="{ item }">
                                        <v-btn icon small v-if="item.fileUrl" :href="item.fileUrl+'?ticket=' + generateRandom10DigitNumber()" target="_blank" color="error">
                                            <v-icon size="24">mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                        <span v-else class="text--disabled">—</span>
                                    </template>
                                </v-data-table>
                            </div>

                            <v-divider class="mx-6 mb-10"></v-divider>

                            <!-- Assignment Section -->
                            <div class="px-6 mb-10">
                                <div class="d-flex align-center mb-6">
                                    <v-icon color="teal darken-3" class="mr-3" size="28">mdi-history</v-icon>
                                    <h3 class="text-h6 font-weight-bold teal--text text--darken-4 text-uppercase" style="letter-spacing: 1px;">Lịch sử công việc</h3>
                                </div>
                                <v-data-table :headers="assignHeader" :items="assignHistory" class="elevation-0 border-teal-lighten-5">
                                    <template v-slot:[`item.validFrom`]="{ item }">
                                        <span class="font-weight-bold teal--text text--darken-1">{{ $formatter.formatDate(item.validFrom, "DD/MM/YYYY") }}</span>
                                    </template>
                                </v-data-table>
                            </div>

                            <v-divider class="mx-6 mb-10"></v-divider>

                            <!-- Leave Section -->
                            <div class="px-6 mb-4">
                                <div class="d-flex align-center mb-6">
                                    <v-icon color="teal darken-3" class="mr-3" size="28">mdi-calendar-star</v-icon>
                                    <h3 class="text-h6 font-weight-bold teal--text text--darken-4 text-uppercase" style="letter-spacing: 1px;">Danh sách phép nghỉ</h3>
                                </div>
                                <v-data-table :items="LeaveEnrollmentTable" :headers="LeaveEnrollmentHeader" class="elevation-0 border-teal-lighten-5">
                                    <template v-slot:[`item.amount`]="{ item }">
                                        <v-chip color="teal lighten-5" text-color="teal darken-4" small class="font-weight-black">{{ item.amount }} ngày</v-chip>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-tab-item>

                        <v-tab-item :key="1" class="py-6">
                            <!-- Attendance Section -->
                            <div class="px-6 mb-10">
                                <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
                                    <div class="d-flex align-center">
                                        <v-icon color="teal darken-3" class="mr-3" size="28">mdi-fingerprint</v-icon>
                                        <h3 class="text-h6 font-weight-bold teal--text text--darken-4 text-uppercase" style="letter-spacing: 1px;">Lịch sử chấm công</h3>
                                    </div>
                                    <div style="width: 200px;" class="mt-2 mt-sm-0">
                                        <month-picker v-model="monthYear"></month-picker>
                                    </div>
                                </div>
                                <v-data-table :headers="enrollHeader" :items="enrollHistory" class="elevation-0 border-teal-lighten-5">
                                    <template v-slot:[`item.enrollDate`]="{ item }">
                                        <span class="font-weight-medium">{{ formatDate(item.enrollDate) }}</span>
                                    </template>
                                    <template v-slot:[`item.late`]="{ item }">
                                        <v-chip v-if="item.late > 0" x-small color="error lighten-5" text-color="error" class="font-weight-bold">{{ item.late }}'</v-chip>
                                        <span v-else class="grey--text">—</span>
                                    </template>
                                    <template v-slot:[`item.early`]="{ item }">
                                        <v-chip v-if="item.early > 0" x-small color="orange lighten-5" text-color="orange darken-4" class="font-weight-bold">{{ item.early }}'</v-chip>
                                        <span v-else class="grey--text">—</span>
                                    </template>
                                </v-data-table>
                            </div>

                            <v-divider class="mx-6 mb-10"></v-divider>

                            <!-- Timesheet Section -->
                            <div class="px-6 mb-4">
                                <div class="d-flex align-center mb-6">
                                    <v-icon color="teal darken-3" class="mr-3" size="28">mdi-calendar-clock</v-icon>
                                    <h3 class="text-h6 font-weight-bold teal--text text--darken-4 text-uppercase" style="letter-spacing: 1px;">Bảng tổng hợp công</h3>
                                </div>
                                <v-data-table :headers="timesheetHeader" :items="timesheetTable" class="elevation-0 border-teal-lighten-5">
                                    <template v-slot:[`item.workDate`]="{ item }">
                                        <span class="font-weight-medium">{{ formatDate(item.workDate) }}</span>
                                    </template>
                                    <template v-slot:[`item.isConfirmed`]="{ item }">
                                        <v-icon v-if="item.isConfirmed" color="teal">mdi-check-circle</v-icon>
                                        <v-icon v-else color="grey lighten-2">mdi-minus-circle-outline</v-icon>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                    <v-spacer></v-spacer>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import http from '@/components/services/http-common'
import * as moment from "moment/moment"
import BreadCrumb from '@/components/BreadCrumb'
import EditProfile from './EditProfile';
import EventBus  from "@/components/services/EventBus";
import ApiCaller  from "./js/api.js";

export default {
    name: "Profile",
    components: {
        "myBreadCrumb": BreadCrumb,
        "edit-profile-dialog": EditProfile
    },

    //ANCHOR DATA
    data() {
        return {
            // CONST
            ACCOUNT_URL: "account",
            ENROLL_FETCH_URL: "account/enrollment/",

            editDialog: false,
            icon: {
                icon: "",
                to: ""
            },
            formData: {
                gender: [
                    {text: "Nam", value: "0"},
                    {text: "Nữ", value: "1"},
                ]
            },

            //Update account
            newAvatar: null,
            account: {
                UserName: "",
                Password: "",
                ConfirmPassword: "",
            },

            tabIndex: 0,
            tabContent: 0,
            showChangeAvatar: false,

            data: {
                faceDetectRs: null,
                avatar: "",
                name: "",
                mail: "",
                phone: "",
                birthDay: "",
                gender: false,
                marriageCode: "",
                email: "",
                idNumber: "",
                idDate: "",
                idPlace: "",
                bankName:"",
                bankNumber: "",

                //address
                address: "",
                city: "",
                district: "",
                ward: "",

                dCityName:"",
                dDistrictName:"",
                dWardName:"",
                domicileAddress:"",
                
                educationLevelName: "",
                universityName: "",
                academicRankName: "",
                majorName: "",
                
                //work
                currentGroup: "",
                currentDepartment: "",
                currentPosition: "",
                currentShift: "",
            },
            endpoint: process.env.VUE_APP_BASE_URL,


            //ENROLLMENTS DATA
            headers: [
                    {text: "", value: "isCheckIn", sortable: false},
                    {text: "Ngày", value: "EnrollmentDate" },
                    {text: "Thời gian", value: "EnrollmentTime" }
            ],
            
            //assignmentHistory
            assignHistory: [],
            assignHeader:[
                {text: "Phòng ban", value: "departmentName"},
                {text: "Vị trí", value: "positionName"},
                {text: "Chức danh", value: "positionStateName"},
                // {text: "Ca làm việc", value: "shift"},
                {text: "Ngày chuyển", value: "validFrom"}
            ],

            contractStatusDict: {
                0: {name: "Tạo mới", color: "light-green"},
                1: {name: "Hoàn thành", color: "success"},
                2: {name: "Chờ nhân viên xác nhận", color: "blue"},
                4: {name: "Trả về", color: "error"},
                3: {name: "Chờ duyệt", color: "warning"},
            },
            contractNote: "",
            contractHeader: [
                {text: "ID", value: "id"},
                {text: "Mã", value: "contractNumber"},
                {text: "Loại HĐ", value: "contractCategoryCode"},
                {text: "Ngày ký", value: "validFrom"},
                {text: "Ngày hết hạn", value: "validTo"},
                {text: "Lương", value: "salary"},
                // {text: "Phụ cấp", value: "allowance"},
                // {text: "Phụ cấp khác", value: "otherAllowance"},
                {text: "Trạng thái", value: "status"},
                {text: "Preview", value: "htmlSource"},
                {text: "File", value: "fileUrl"},
            ],
            contractHistory: [],

            //Leave Enrollments
            LeaveEnrollment: false,
            LeaveEnrollmentTable: [],
            LeaveEnrollmentHeader: [
                {text: "Mã", value: "code"},
                {text: "Tên", value: "name"},
                {text: "Còn lại", value: "amount"},
                // {text: "Hạn dùng", value: "expireDate"},
            ],
            
            // Enrollments
            enrollHistory: [],
            enrollHeader: [
                {text: "Ngày chấm công", value: "enrollDate"},
                {text: "Checkin", value: "checkinTime"},
                {text: "Checkout", value: "checkoutTime"},
                {text: "Nơi checkout", value: "department"},
                {text: "Trễ", value: "late"},
                {text: "Về sớm", value: "early"},
                {text: "Số giờ", value: "actualTime"},
            ],
            timesheetTable:[],
            monthYear: moment().format("YYYY/MM"),
            timesheetHeader: [
                {text: "Ngày công", value: "workDate"},
                {text: "Giờ công làm việc", value: "actualWorkTime"},
                {text: "Giờ công ngoài giờ", value: "extendedTime"},
                {text: "Giờ công xác nhận làm thêm", value: "overtime"},
                {text: "Hệ số tăng ca", value: "overtimeScale"},
                {text: "Xác nhận", value: "isConfirmed"},
            ],
            iOSCode:"************"
        }
    },
    computed: {
        ClientUser () {
            let result = localStorage.getItem("user");
            result = JSON.parse(result);
            return result;
        },
        avatarUrl(){
            return this.data.avatar
            // return this.data.avatar ? this.endpoint + this.data.avatar :'https://cdn.vuetifyjs.com/images/lists/ali.png';
        }
    },
    methods: {
        generateRandom10DigitNumber() {
            const min = 1000000000; // Smallest 10-digit number (10 zeros)
            const max = 9999999999; // Largest 10-digit number (nine nines)

            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        dialogHandler() {
            this.editDialog = false;
        },

        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        // ********* FETCH SECTIONS *******
        fetchData () {
            http.get("account/").then((res)=> {
                let data= res.data;
                this.faceDetectRs = res.data.faceDetectRs;
                this.data = Object.assign({}, res.data.employee);
                this.account = Object.assign({}, res.data.account);
            }).catch((err) => {
                console.log(err)
            });
        },

        //General Info tab handler
        tabInfoHandler() {
            console.log("tab1");
        },
        tabHistoryHandler() {
            const assign = http.get(this.ACCOUNT_URL + "/assign-history")
            .then(res => {
                let data= res.data;
                this.assignHistory = data.data;
            })
            
            const contract = http.get(this.ACCOUNT_URL + "/contract-history")
            .then(res => {
                let data= res.data;
                this.contractHistory = data.items;
            })
            
            const leave = http.get(this.ACCOUNT_URL + "/leave-enrollment")
            .then(res => {
                let data= res.data;
                this.LeaveEnrollmentTable = data.items;
            })
            
            return http.all([assign, contract, leave]).then(http.spread((...responses) => {
                const assign = responses[0]
                const contract = responses[1]
                const leave = responses[2]
                const timesheet = responses[3]
            })).catch(errors => {
            })
            
        },
        
        
        tabEnrollmentHandler() {
            const enroll = http.get(this.ENROLL_FETCH_URL).then(res => {
                this.enrollHistory = res.data.items;
            });
            
            const timesheet = http.get(this.ACCOUNT_URL + "/timesheet", {
                params:{
                    monthYear: this.monthYear,
                }
            }).then(res=>{
                this.timesheetTable = res.data.items
            })
            return http.all([enroll, timesheet]).then(http.spread((...responses) => {
                const enroll = responses[0];
                const timesheet = responses[1];
            }));
        },
        messageToast (eventObj) {
            EventBus.$emit('hasMessage', eventObj);
        },

        updateAccount () {
            return http.post(this.ACCOUNT_URL+ "/change-password", this.account)
                    .then(res => {
                        let eventObj = {
                            color: "success",
                            message: "Cập nhật thành công",
                            toast: false,
                        };
                        this.messageToast(eventObj);
                    })
                    .catch(err => {
                    });
        },

        getIosCode()
        {
            return http.get("account/get-ios-code", this.account).then(res => {
                this.iOSCode = res.data.data
            })
        },
        
        changeContractStatus(id, status) {
            if(status == 4 && !this.contractNote){
                alert("Bạn phải nhập nội dung trả về")
                return
            }
            return ApiCaller.changeContractStatus(id, status, this.contractNote).then(()=>{
                this.tabHistoryHandler()
                this.contractNote = ""
            })
        },
        changeAvatar() {
            
            var reader = new FileReader()
            var that = this
            reader.onloadend = function () {
                console.log('RESULT', reader.result)
                return http.post('account/change-avatar', {
                    Base64Avatar: reader.result
                }).then(() => {
                    that.newAvatar = null
                    that.fetchData()
                    that.showChangeAvatar = false
                })
            }
            reader.readAsDataURL(this.newAvatar)

        }
    },
    created(){
        this.fetchData();
        this.tabHistoryHandler()
    }
    
}
</script>
<style scoped>

</style>